import script from "./RevenueComparisonChartCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenueComparisonChartCard.vue?vue&type=script&setup=true&lang=js"

import "./RevenueComparisonChartCard.vue?vue&type=style&index=0&id=0ff3618a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ff3618a"]])

export default __exports__